﻿import React, { useState, useEffect } from 'react';
import TemperatureProgramEditor from './Analysis/TemperatureProgramEditor';
import { OvenTemperatureProgram } from '../models/oven-temperature-program';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Paging,
    Selection,
    Toolbar,
    LoadPanel,
    Item as ToolbarItem
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
//import TemperatureProgramComponent from './TemperatureProgramComponent';

export interface Props {
    benchSheetId?: string;
    isReadOnly: boolean;
    datagridHeight?: string;
}

export default function TemperatureProgramDataComponent(props: Props) {
    const [ovenTemperatureProgramEntries, setOvenTemperatureProgramEntries] =
        useState<OvenTemperatureProgram[]>();

    const [temperatureProgamDialogVisible, setTemperatureProgamDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getOvenTemperaturePrograms();
    }, [props.benchSheetId]);

    return (
        <div>
            <div id="temperatureProgramComponentDatagrid">
                <DataGrid 
                    height={props.datagridHeight ? props.datagridHeight : "100%"}
                    wordWrapEnabled={true}
                    keyExpr="ovenTemperatureProgramId"
                    dataSource={ovenTemperatureProgramEntries ?
                        ovenTemperatureProgramEntries : []}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true} >
                    
                    <LoadPanel enabled={true} />
                    <Selection mode={'single'} />
                    <Paging enabled={false} />

                    <Column dataField={'rowNumber'} caption="" dataType="number" width={'3em'} allowEditing={false} />
                    <Column dataField={'initTemperature'} caption="Init Temp °C" dataType="number" width={'21%'} />
                    <Column dataField={'timeIncrement1'} caption="Hold Time (min)" dataType="number" width={'16%'} />
                    <Column dataField={'secondTemperature'} caption="Second Temp °C" dataType="number" width={'21%'} />
                    <Column dataField={'timeIncrement2'} caption="Hold Time (min)" dataType="number" width={'16%'} />
                    <Column dataField={'rate'} caption="Rate °C/min" dataType="number" width={'18%'} />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Temperature Program</div>
                            </div>
                        </ToolbarItem>

                        {!props.isReadOnly &&
                            <ToolbarItem location="after">
                                <Button hint="Edit" icon="edit" type="success"
                                    width="1.8rem" onClick={showTemperatureProgamDialog} />
                            </ToolbarItem>
                        }
                    </Toolbar>
                    
                </DataGrid>
            </div>

            {temperatureProgamDialogVisible &&
                <DialogPopup
                    visible={temperatureProgamDialogVisible}
                    onHiding={hideTemperatureProgamDialog}
                    dragEnabled={false}
                    width="90vw" height="90vh"
                    hideOnOutsideClick={false}
                    title="Temperature Program">
                    <TemperatureProgramEditor benchSheetId={props.benchSheetId}
                        onClose={onCloseTemperatureProgramDialog} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );
     
    function onCloseTemperatureProgramDialog() {
        getOvenTemperaturePrograms();
        hideTemperatureProgamDialog();
    }
    
    // CRUD functions

    async function getOvenTemperaturePrograms() {
        await CrudFunctions.getData(`benchsheets/oventemperatureprogramsbybenchSheetid/${props.benchSheetId}`)
            .then(data => {
                setOvenTemperatureProgramEntries(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Temperature Program");
            });
    }
 
    function showTemperatureProgamDialog(){
        setTemperatureProgamDialogVisible(true);
    }

    function hideTemperatureProgamDialog() {
        setTemperatureProgamDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}